import React from 'react';
import { MdCloudDownload } from 'react-icons/md';
import { OutlineButton } from './OutlineButton';

type CreateButtonProps = {
  label?: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
};

export const ExportButton: React.FC<CreateButtonProps> = ({
  label,
  onClick,
  loading,
  disabled,
}) => {
  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      isLoading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </OutlineButton>
  );
};
